import "./App.css"
import Home from "./pages/Home"
// import {AiFillDelete} from "react-icons/ai"
const App = () => {
  return (
    <div>
      <Home />
      {/* <AiFillDelete className="text-danger fs-3"/> */}
    </div>
  )
  
}

export default App
